import React, { useState, useMemo } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import {
  Grid, Paper, InputBase, InputAdornment, Typography, Button, Fab, Accordion, AccordionSummary,
  AccordionDetails, IconButton, Tooltip, Card, CardContent, Modal, Backdrop, Grow, Fade
} from '@material-ui/core'

import { ExpandMore, Clear, Create, Delete, AddCircle, Search, RemoveCircleOutline } from '@material-ui/icons'

import { withStyles } from '@material-ui/core/styles'

import WhitelistNew from './WhitelisteNew'

import { ValidateUrl, handleUrlPrepper, handleTextPrepper } from '../../../../utils'

import { NotificationToast } from '../../tools/Toast'

import ConfirmToast from '../../tools/ConfirmToast'

import { deleteWhitelistItem, getWhitelist, addWhitelistItem, updateWhitelistItem, getWhiteListSearch } from '../../../../redux/actions'

import moment from 'moment'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 18,
    leaveTouchDelay: 10000
  }
}))(Tooltip)

const WhitelistList = (props) => {
  const { whitelistsInfo, whitelistItems, classes, unitID } = props
  const dispatch = useDispatch()
  const currentSupervisor = useSelector(state => state.auth.supervisorID)

  const [searchVal, setSearchVal] = useState('')
  const [currentWhitelist, setCurrentWhitelist] = useState([])
  const [form, setForm] = useState('list')

  const [siteInfo, setSiteInfo] = useState('')
  const [descriptionInfo, setDescriptionInfo] = useState('')
  const [keyboardInfo, setKeyboardInfo] = useState(true)
  const [applicationInfo, setApplicationInfo] = useState(true)
  const [whitelistID, setWhitelistID] = useState('')

  const [openSearch, setOpenSearch] = useState(false)
  const [openModal, setOpenModal] = useState(false)

  const [confirmAnchorEl, setConfirmAnchorEl] = useState(null)

  useMemo(() => { if (whitelistItems) setCurrentWhitelist(whitelistItems) }, [whitelistItems])

  // Checks to see if website is already in database
  const handleSiteProcess = (newSite, newDescription, newKeyboard, newApplication) => {
    if (newSite === '') {
      NotificationToast(false, 'Whitelist item must have a url.', true)
    } else {
      if (!ValidateUrl(newSite)) {
        NotificationToast(false, 'Invalid URL.', true)
      } else {
        const siteInfo = {
          site: handleUrlPrepper(newSite),
          description: handleTextPrepper(newDescription),
          keyboard: newKeyboard ? 1 : 0,
          application: newApplication ? 1 : 0
        }

        const searchSite = siteInfo.site
        // If the user is trying to add a site this will dispatch the search, if editing it will dispatch the update
        if (form === 'list') {
          dispatch(getWhiteListSearch(unitID, searchSite, siteInfo, fireSearchSuccess, fireSearchFailure))
        } else if (form === 'edit') {
          dispatch(updateWhitelistItem(currentSupervisor, unitID, whitelistID, siteInfo, fireUpdateSuccess, fireUpdateFailure))
        }

        setConfirmAnchorEl(null)
      }
    }
  }

  // website is already in database
  const fireSearchSuccess = () => {
    NotificationToast(true, 'Site already exists in Unit WhiteList.')
  }
  // website is NOT in database already
  const fireSearchFailure = (siteInfo) => {
    dispatch(addWhitelistItem(unitID, siteInfo, fireAddSuccess, fireAddFailure))
  }
  const fireAddSuccess = async () => {
    await dispatch(getWhitelist(unitID))
    setOpenModal(false)
    NotificationToast(false, 'Successfully added whitelist site!')
  }

  const fireAddFailure = () => {
    NotificationToast(true, 'Failed to add whitelist site!')
  }

  const fireUpdateSuccess = () => {
    NotificationToast(false, 'Successfully updated whitelist site!')
    dispatch(getWhitelist(unitID))

    setSiteInfo('')
    setDescriptionInfo('')
    setWhitelistID('')

    setOpenModal(false)
  }

  const fireUpdateFailure = () => {
    NotificationToast(true, 'Failed to update whitelist site!')
  }

  const handleClearSearch = () => {
    setSearchVal('')
  }

  const handleNewItem = () => {
    setForm('list')
    setSiteInfo('')
    setDescriptionInfo('')
    setOpenModal(true)
  }

  const handleEditItem = (whitelistInfo) => {
    const { whitelistID, site, description, keyboard, application } = whitelistInfo
    setWhitelistID(whitelistID)
    setSiteInfo(site)
    setDescriptionInfo(description)
    setKeyboardInfo(keyboard === 1)
    setApplicationInfo(application === 1)
    setForm('edit')
    setOpenModal(true)
  }

  const handleWhitelistDelete = async (whitelistID) => {
    const confirm = await ConfirmToast({ msg: 'Are you sure you want to delete this item?', text: '' })
    if (confirm) {
      dispatch(deleteWhitelistItem(unitID, whitelistID, fireDeleteSuccess, fireDeleteFailure))
    }
  }

  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Successfully deleted whitelist site!')
    dispatch(getWhitelist(unitID))
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to delete whitelist site!')
  }

  const handleSearchOpen = () => {
    if (openSearch) {
      setOpenSearch(false)
    } else {
      setOpenSearch(true)
    }
  }

  const filteredList = currentWhitelist.filter(
    (item) => item.site.toLowerCase().includes(searchVal.toLowerCase()) ||
      item.description.toLowerCase().includes(searchVal.toLowerCase())
  )

  return (
    <>
      <Modal
        className={classes.siteModal}
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={openModal}>
          <div>
            <WhitelistNew
              classes={classes}
              whitelistsInfo={whitelistsInfo}
              onBackTrack={() => setOpenModal(false)}
              site={siteInfo}
              description={descriptionInfo}
              keyboard={keyboardInfo}
              application={applicationInfo}
              onTrigger={handleSiteProcess}
              type={form}
              confirmAnchorEl={confirmAnchorEl}
              setConfirmAnchorEl={setConfirmAnchorEl}
            />
          </div>
        </Fade>
      </Modal>
      <Paper elevation={2}>
        <Grid
          container
          direction='column'
          justify='center'
          className={`px-3 w-100 py-3 mx-auto my-auto ${classes.whitelistContainer}`}
          spacing={2}
        >
          <Grid container item>
            <Grid container item xs={8} alignContent='center'>
              <Typography component='h5' variant='h5'>
                {whitelistsInfo.unitName ? whitelistsInfo.unitName.replace('_', ' ') : ''} Whitelist
              </Typography>
            </Grid>
            <Grid container item xs={4} justify='center' spacing={1}>
              {currentWhitelist.length !== 0 &&
                (
                  <>
                    <Grid item>
                      <Tooltip
                        title={
                          <Typography variant='body1' component='p'>
                            Search for a site
                          </Typography>
                        }
                        enterDelay={500}
                        placement='top'
                      >
                        <Fab
                          className={classes.blueBtn}
                          onClick={handleSearchOpen}
                          size='large'
                        >
                          {openSearch ? <RemoveCircleOutline /> : <Search />}
                        </Fab>
                      </Tooltip>
                    </Grid>

                    <Grid item>
                      <Tooltip
                        title={
                          <Typography variant='body1' component='p'>
                            Create New Whitelist Site
                          </Typography>
                        }
                        enterDelay={500}
                        placement='top'
                      >
                        <Fab
                          className={classes.greenBtn}
                          onClick={handleNewItem}
                          size='large'
                        >
                          <AddCircle />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </>)}
            </Grid>
          </Grid>

          <Grow in={openSearch} timeout={500} unmountOnExit>
            <Grid container item>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <Fab
                    className={classes.searchBtn}
                    size='small'
                  >
                    <Search />
                  </Fab>
                </div>
                <InputBase
                  placeholder='www.google.com'
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput
                  }}
                  inputProps={{ 'aria-label': 'search' }}
                  onChange={(e) => {
                    setSearchVal(e.target.value)
                  }}
                  value={searchVal}
                  endAdornment={
                    <>
                      {
                        searchVal !== '' &&
                        (
                          <InputAdornment position='start'>
                            <IconButton onClick={handleClearSearch}>
                              <Clear />
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                    </>
                  }
                />
              </div>
            </Grid>
          </Grow>

          <Grid container item justify='center' className={classes.listContainer}>
            {
              currentWhitelist.length === 0
                ? (
                  <>
                    <Grid container direction='column' justify='center' spacing={2}>
                      <Grid item>
                        <Typography
                          variant='h5'
                          component='h2'
                          className='w-100 text-break text-primary font-weight-bold'
                          align='center'
                        >
                          No Whitelist Created
                        </Typography>
                      </Grid>

                      <Grid item container justify='center'>
                        <Button
                          variant='contained'
                          className={classes.greenBtn}
                          onClick={handleNewItem}
                        >
                          Add New
                        </Button>
                      </Grid>
                    </Grid>
                  </>)
                : searchVal !== '' && filteredList.length === 0
                  ? (
                    <Card raised className={classes.whitelistCard}>
                      <CardContent>
                        <Typography variant='h5' component='h2' className={`w-100 text-break text-primary font-weight-bold ${classes.siteDescription}`}>
                          No Results For "{searchVal}"
                        </Typography>
                      </CardContent>
                    </Card>)
                  : (searchVal === ''
                      ? currentWhitelist
                      : filteredList).map((whitelist, index) => {
                      const { whitelistID, site, description, createdAt, createdByFirstName, createdByLastName, lastModified } = whitelist
                      const formattedName = createdByFirstName && createdByFirstName ? `${createdByFirstName} ${createdByLastName}` : 'Unavailable'
                      return (
                        <Card key={`whitelist-${whitelistID}`} raised className={classes.whitelistCard}>
                          <Grid container direction='row' spacing={2}>
                            <Grid item xs={8}>
                              <CardContent>
                                <LightTooltip title={site} placement='left'>
                                  <Typography
                                    variant='h6'
                                    component='h2'
                                    className='text-break text-primary font-weight-bold text-truncate'
                                  >
                                    {site}
                                  </Typography>
                                </LightTooltip>

                                <Typography
                                  variant='body2'
                                  color='textSecondary'
                                  component='p'
                                  className={`text-break text-capitalize ${classes.siteDescription}`}
                                >
                                  {description}
                                </Typography>

                              </CardContent>
                            </Grid>
                            <Grid item container direction='row' xs={4} justify='center' spacing={1} alignItems='center'>
                              <Grid item>
                                <Fab
                                  className={classes.greenBtn}
                                  onClick={() => handleEditItem(whitelist)}
                                  size='medium'
                                >
                                  <Create />
                                </Fab>
                              </Grid>

                              <Grid item>
                                <Fab
                                  className={classes.deleteBtn}
                                  onClick={() => handleWhitelistDelete(whitelistID)}
                                  size='medium'
                                >
                                  <Delete />
                                </Fab>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item container direction='column' spacing={1}>
                            <Accordion style={{ boxShadow: 'none', borderTop: '0.8px solid #0000002b', borderRadius: 0, padding: '0.5em' }}>
                              <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls='panel1a-content'
                                id='panel1a-header'
                              >
                                <Typography>Additional Details</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid item container direction='column' spacing={1}>
                                  <Grid item>
                                    <Grid item container direction='row' alignItems='center' spacing={2}>
                                      <Grid item>
                                        <Typography style={{ fontWeight: 600 }}>
                                          Created At:
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography>
                                          {createdAt ? moment.unix(createdAt).format('MM/DD/YYYY') : 'Unavailable'}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item>
                                    <Grid item container direction='row' alignItems='center' spacing={2}>
                                      <Grid item>
                                        <Typography style={{ fontWeight: 600 }}>
                                          Created By:
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography>
                                          {formattedName}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item>
                                    <Grid item container direction='row' alignItems='center' spacing={2}>
                                      <Grid item>
                                        <Typography style={{ fontWeight: 600 }}>
                                          Last Modified:
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography>
                                          {lastModified ? moment.unix(lastModified).format('MM/DD/YYYY') : 'Unavailable'}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        </Card>
                      )
                    })
            }
          </Grid>
        </Grid>
      </Paper>
    </>
  )
}

export default WhitelistList
